export default "__VITE_ASSET__BzuAwRVb__"